import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
// BE CAREFUL THIS IS ONLY FOR DASHBOARD
// This is Only for Debug While developmet will be deleted later :)
// const missingKeysCollector = {
//   //eslint-disable-next-line
//   keys: new Set(),
//
//   add(lng, ns, key) {
//     const fullKey = `${ns}:${key}`; // Format: "namespace:key"
//     this.keys.add(fullKey);
//     this.logToConsole();
//   },
//
//   logToConsole() {
//     // Clear console first for fresh output
//     console.clear();
//
//     // Group all missing keys for easy copying
//     console.groupCollapsed(
//       `Missing translation keys (${this.keys.size}) - Copy below this line ↓`
//     );
//     console.log('[');
//     Array.from(this.keys)
//       .sort()
//       .forEach((key) => {
//         console.log(`  "${key}",`);
//       });
//     console.log(']');
//     console.groupEnd();
//
//     // Simple instruction
//     console.log('%cHow to use:', 'color: #4CAF50; font-weight: bold;');
//     console.log('1. Expand the group above');
//     console.log(
//       '2. Copy all lines between (and including) the square brackets'
//     );
//     console.log('3. Paste into your translation file');
//   },
// };

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    ns: ['common', 'active-substance', 'active-substance-details', 'product', 'treatment-search'],
    defaultNS: 'translations',
    debug: false, // process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    keySeparator: '.',
    nsSeparator: '|',
    backend: {
      loadPath:
        process.env.NODE_ENV === 'development'
          ? 'http://localhost:9091/locales/client/{{lng}}/{{ns}}.json'
          : '/static/locales/client/{{lng}}/{{ns}}.json',
    },
    saveMissing: false,
    // missingKeyHandler: function (lng, ns, key) {
    //   missingKeysCollector.add(lng, ns, key);
    // },
  });

export default i18n;
